module.exports = __webpack_public_path__ + "media/bootstrap-icons/reply-all-fill-25d1e1e8.svg";